<template>
    <div>
        <section class="q10__jumbotron">
            <image-with-descriptions
                class="mb-8 mt-0"
                :options="{
                    image:
                        'pages/' +
                        currentPage.slug +
                        '/' +
                        currentPage.images.oImage1.src,
                    descriptions: [
                        {
                            text: currentPage.images.oImage1.edf,
                            position: 'bottom-right', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        },
                    ],
                }"
            />
        </section>
        <div class="page">
            <div class="container px-11 2xl:px-3 mb-14 m-auto">
                <title-s-chapter
                    :options="{
                        from: 'selective_green',
                        to: 'to-golden_sand',
                    }"
                >
                    <h1 v-html="currentPage.content.sArticleTitle.title"></h1>
                </title-s-chapter>
                <p
                    class="font-bold text-tundora text-xl mb-5"
                    v-html="currentPage.content.sArticleDescription.text"
                ></p>
                <div class="container-components lg:mb-8">
                    <div class="card">
                        <div class="relative mt-8">
                            <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        `Gilboa, de l’hydro dans le mix israélien`
                                    ),
                                }"
                                class="-top-10 right-2 md:-top-12 md:-right-3 lg:right-2 lg:-top-6 "
                            />
                        </div>
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'top',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.sParagraphOne_Title.text
                                "
                            ></span>
                        </TitleParagraph>
                        <p
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphOne_Content.text
                            "
                        ></p>
                    </div>
                    <div class="card">
                        
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'bottom',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.sParagraphTwo_Title.text
                                "
                            ></span>
                        </TitleParagraph>
                        <p
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphTwo_Content.text
                            "
                        ></p>
                        <div>
                            <div class="relative">
                                <hotspot-richmedia
                                    :options="{
                                        icon: 'diaporama',
                                        collection: getRichmediaByCollection(
                                            currentPage,
                                            `Remplacement des conduites forcées de Sabart (2017-2019)`
                                        ),
                                    }"
                                    class="top-2 right-2"
                                />
                            </div>
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage2.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage2
                                                .edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                    </div>
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'bottom',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.sParagraphThree_Title
                                        .text
                                "
                            ></span>
                        </TitleParagraph>
                        <span
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphThree_Content.text
                            "
                        ></span>
                        <!-- <Dots
                            :options="{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                            }"
                        /> -->
                        <div>
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage3.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage3
                                                .edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                    </div>
                    <div class="card">
                        <div class="relative">
                            <!-- <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        'Évacuation des crues : PKW, l’innovation virtuose '
                                    ),
                                }"
                                class="top-2 right-2"
                            /> -->
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage4.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage4
                                                .alt,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                        {
                                            text: currentPage.images.oImage4
                                                .text,
                                            position: 'top-left', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                            
                        </div>
                        <div class="relative mt-12">
                            <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        'PKWeir, l’innovation virtuose'
                                    ),
                                }"
                                class="-top-10 md:-top-10 lg:-top-11 right-5 md:-right-2 lg:right-8 xl:-top-11 xl:right-3"
                            />
                        </div>
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'top',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.sParagraphFour_Title
                                        .text
                                "
                            ></span>
                        </TitleParagraph>
                        <span
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphFour_Content.text
                            "
                        ></span>
                        <!-- <Dots
                            :options="{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                            }"
                        /> -->
                        <image-with-descriptions
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.oImage5.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.oImage5.alt,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                    {
                                        text: currentPage.images.oImage5.text,
                                        position: 'top-left', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                    </div>
                </div>

                <image-with-descriptions
                    class="mb-4 lg:mb-8 q10_image-redimensioned"
                    :options="{
                        image:
                            'pages/' +
                            currentPage.slug +
                            '/' +
                            currentPage.images.oImage6.src,
                        descriptions: [
                            {
                                text: currentPage.images.oImage6.alt,
                                position: 'bottom-right', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            },
                            {
                                text: currentPage.images.oImage6.text,
                                position: 'top-left', // top/bottom-left/right
                                orientation: 'horizontal', // vertical, horizontal
                            },
                        ],
                    }"
                />
                <div class="container-components mb-8">
                    <div class="card">
                        <div class="relative mt-8">
                            <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        'Débit réservé : la calebasse, une innovation brevetée'
                                    ),
                                }"
                                class="-top-10 right-2"
                            />
                        </div>
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'bottom',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.sParagraphFive_Title
                                        .text
                                "
                            ></span>
                        </TitleParagraph>
                        <p
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphFive_Content.text
                            "
                        ></p>
                        <div class="relative">
                            <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        'Débit réservé : le vivant avant tout'
                                    ),
                                }"
                                class="top-2 right-2"
                            />
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage7.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage7
                                                .alt,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                        {
                                            text: currentPage.images.oImage7
                                                .text,
                                            position: 'top-left', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                    </div>
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'bottom',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.sParagraphSix_Title.text
                                "
                            ></span>
                        </TitleParagraph>
                        <p
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphSix_Content.text
                            "
                        ></p>
                        <image-with-descriptions
                            class="mb-8"
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.oImage8.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.oImage8.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                    </div>
                    <div class="card break-inside-avoid">
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'bottom',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.sParagraphSeven_Title
                                        .text
                                "
                            ></span>
                        </TitleParagraph>
                        <span
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphSeven_Content.text
                            "
                        ></span>
                        <!-- <Dots
                            :options="{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                            }"
                        /> -->
                    
                        <div class="relative">
                            <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        'Barrage du Chambon - Travaux de confortement (2014)'
                                    ),
                                }"
                                class="top-2 right-2"
                            />
                            <image-with-descriptions
                                class="mb-8"
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage9.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage9
                                                .edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                    </div>
                    <div class="card">
                        <!-- <Dots
                            :options="{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                            }"
                        /> -->

                        <span
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphEight_Content.text
                            "
                        ></span>
                        <Triangles
                            :options="{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                direction: 'bottom',
                            }"
                        />
                        <image-with-descriptions
                            class="mb-8"
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.oImage10.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.oImage10.alt,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                    {
                                        text: currentPage.images.oImage10.text,
                                        position: 'top-left', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                    </div>
                    <div class="card " style="padding-top: 0;">
                        
                        <div class="card break-inside-avoid">
                        <div class="relative">
                            <hotspot-richmedia
                            :options="{
                                icon: 'diaporama',
                                collection: getRichmediaByCollection(
                                    currentPage,
                                    'Remplacement des robinets sphériques de Lardit'
                                ),
                            }"
                            class="top-9 right-2"
                        />
                    </div>
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'bottom',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.sParagraphNine_Title
                                        .text
                                "
                            ></span>
                        </TitleParagraph>
                        <image-with-descriptions class="eliminate-margin"
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.oImage11.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.oImage11.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                        
                        
                        <span
                            class="text-nandor 2xl:text-lg"
                            v-html="
                                currentPage.content.sParagraphNine_Content.text
                            "
                        ></span>
                        <div class="card relative top-7">
                    </div>
                            <TitleParagraph
                                :options="{
                                    from: 'from-selective_green',
                                    to: 'to-golden_sand',
                                }"
                            >
                                <Triangles
                                    :options="{
                                        colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                        direction: 'bottom',
                                    }"
                                />
                                <span
                                    v-html="
                                        currentPage.content.sParagraphTen_Title.text
                                    "
                                ></span>
                            </TitleParagraph>
                            <span
                                class="text-nandor 2xl:text-lg"
                                v-html="
                                    currentPage.content.sParagraphTen_Content.text
                                "
                            ></span>
                            <!-- <Square
                                :options="{
                                    from: 'from-golden_sand',
                                    to: 'to-sushi',
                                }"
                            /> -->
                            <div class="relative">
                                <hotspot-richmedia
                                    :options="{
                                        icon: 'diaporama',
                                        collection: getRichmediaByCollection(
                                            currentPage,
                                            'Tolla : opération de colmatage en eaux profondes'
                                        ),
                                    }"
                                    class="top-2 right-2"
                                />
                                <!-- <hotspot-richmedia
                                    :options="{
                                        icon: 'diaporama',
                                        collection: getRichmediaByCollection(
                                            currentPage,
                                            'Tolla : vidanger ou plonger ? '
                                        ),
                                    }"
                                    class="-top-2 right-16 md:-top-4 md:right-16 lg:-top-2 lg:right-16"
                                /> -->
                            </div>
                            <image-with-descriptions style="margin: 0"
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage12.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage12.edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                        <div class="card">
                            <article-note
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.oImage13.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.oImage13.edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                    verticalcontent:
                                        currentPage.content.sParagraphEleven_Title
                                            .text,
                                    content:
                                        currentPage.content.sParagraphEleven_Content
                                            .text,
                                    color: {
                                        verticalcontent: 'text-cornflower_blue',
                                        content: 'text-nandor',
                                    },
                                    fontSize: {
                                        verticalcontent: 'text-4xl xl:text-2xl',
                                        content: '',
                                    },
                                }"
                            />
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";
import TitleSChapter from "../../components/TitleSChapter.vue";
import Triangles from "../../components/Triangles.vue";
import TitleParagraph from "../../components/TitleParagraph.vue";
import Paragraph from "../../components/Paragraph.vue";
import ImageWithDescriptions from "../../components/ImageWithDescriptions.vue";
import Square from "../../components/Square.vue";

export default {
    components: {
        TitleSChapter,
        Triangles,
        TitleParagraph,
        ImageWithDescriptions,
        Paragraph,
        Square,
    },
    name : "PageTest",
    mixins: [PagesMixin],
};
</script>

<style scoped lang='scss'>
.q10_image-redimensioned {
    max-height: 600px;
    object-fit: cover;
}
</style>
